import { Card } from 'components/Card';
import { useOutageContext } from 'context/outage/outage.context';
import React from 'react';
import { ContentUtil } from 'utils';
import { dateUtils } from 'utils/date';

import { ConversationalMessageProductTypesEnum } from '../../../api/outage.types';
import IOutageCardProps from './Interface/IOutageCardProps';
import OutageSubscribeForm from './OutageSubscribeForm';
import OutageUnsubscribeForm from './OutageUnsubscribeForm';
import { content as conversationContent } from './conversation.content';
import { content } from './outage-overview.content';
import * as Styles from './outage-overview.styles';

const contentUtil = new ContentUtil({ content, componentName: 'OutageOverview' });
const conversationContentUtil = new ContentUtil({ content: conversationContent, componentName: 'OutageOverview' });

const OutageCard = (props: IOutageCardProps) => {
  const { unsubscribeOutage, subscribeOutage } = useOutageContext();

  const translateProductTypes = (types?: Array<ConversationalMessageProductTypesEnum> | null): string => {
    if (!types) return '';

    // Make sure we only show Ziggo TV once.
    if (
      types.includes(ConversationalMessageProductTypesEnum.CATV) &&
      types.includes(ConversationalMessageProductTypesEnum.DIGITALTV)
    ) {
      types.splice(types.indexOf(ConversationalMessageProductTypesEnum.CATV), 1);
    }

    return types.map((type) => conversationContentUtil.translateToString(`productType.${type}`)).join(', ');
  };

  const translateDate = (date?: string | null): string => {
    if (!date) return contentUtil.translateToString('unknown');

    const dateString = dateUtils.format(date, "d LLLL yyyy 'om' HH:mm");

    return dateString.charAt(0).toUpperCase() + dateString.slice(1).toLowerCase();
  };

  const renderForm = () => {
    return props.subscribed ? (
      <OutageUnsubscribeForm outage={props.outage} phoneNumbers={props.phoneNumbers} onSubmit={unsubscribeOutage} />
    ) : (
      <OutageSubscribeForm outage={props.outage} onSubmit={subscribeOutage} />
    );
  };

  return (
    <Card>
      {props.showHeader !== false && (
        <>
          <Styles.SubHeader>
            <h4>{contentUtil.translateToString(`${props.isPlanned ? 'planned.' : ''}subHeader`)}</h4>
            <p>{contentUtil.translateHtml(`${props.isPlanned ? 'planned.' : ''}subHeaderText`)}</p>
          </Styles.SubHeader>
          <Styles.Divider />
        </>
      )}

      {props.outage && (
        <>
          <Styles.InfoContainer>
            <strong>{contentUtil.translateToString('outageType')}</strong>
            <p data-testid="outage-impacted-products-value">{translateProductTypes(props.outage?.productTypes)}</p>

            <strong>{contentUtil.translateToString('outageStart')}</strong>
            <p>{translateDate(props.outage?.createdDate)}</p>

            <strong>{contentUtil.translateToString('outageEnd')}</strong>
            <p>{translateDate(props.outage?.resolvedDateTime || props.outage?.expectedResolvedDateTime)}</p>
          </Styles.InfoContainer>

          {!props.isPlanned && (
            <>
              <Styles.Divider />
              <Styles.FormContainer>
                <h5>{contentUtil.translateToString('formTitle')}</h5>
                <strong>{contentUtil.translateToString('formSubtitle')}</strong>

                {renderForm()}
              </Styles.FormContainer>
            </>
          )}
        </>
      )}
    </Card>
  );
};

export default OutageCard;
